import app from "./app";
import user from "./user";
import messages from "./messages";
import filters from "./filters";
import notification from "./notification";
import map from "./map";
import adas from "./adas";

export default [
    ...map,
    ...app,
    ...user,
    ...messages,
    ...filters,
    ...notification,
    ...adas
];